import API from "api/axiosInstance";
import {
  setIsLoading,
  setListAbsensiBulanan,
  setListAbsensiHarian,
  setListAbsensiHariIni,
  setOptionsAbsensiBulanan,
  setOptionsAbsensiHarian,
  setMessage,
  setStatus,
} from "./index";

export const fetchListAbsensiHariini = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/api/attendance/absenhariini");
    dispatch(setIsLoading(false));
    dispatch(setListAbsensiHariIni(response.data.list_absensi));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchListAbsensiHarian =
  (params = {}) =>
  async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get("/api/attendance/absenharian", { params });
      dispatch(setIsLoading(false));
      dispatch(
        setListAbsensiHarian({
          list: response.data.list_absensi_harian,
          pagination: response.data.pagination,
        }),
      );
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchOptionsAbsensiHarian = () => async (dispatch) => {
  try {
    const response = await API.get("/api/attendance/absenharian", {
      params: { options: "cabang,nama_jabatan" },
    });
    dispatch(setOptionsAbsensiHarian(response.data.data));
  } catch (error) {
    dispatch(setStatus("failed"));
  }
};

export const fetchListAbsensiBulanan =
  (params = {}) =>
  async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get("/api/attendance/absenbulanan", {
        params,
      });
      dispatch(setIsLoading(false));
      dispatch(
        setListAbsensiBulanan({
          list: response.data.list_absensi_bulanan,
          pagination: response.data.pagination,
        }),
      );
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchOptionsAbsensiBulanan = () => async (dispatch) => {
  try {
    const response = await API.get("/api/attendance/absenbulanan", {
      params: { options: "cabang,bulan" },
    });
    dispatch(setOptionsAbsensiBulanan(response.data.data));
  } catch (error) {
    dispatch(setStatus("failed"));
  }
};

export const fetchEditAbsensi = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/api/attendance/update_absensi", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setMessage(error.response.data.error ?? "Ada Kendala di Server"));
    dispatch(setStatus("failed"));
  }
};

export const fetchDeleteAbsensi = (sesi_id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.delete(`/api/attendance/delete_absensi/${sesi_id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setMessage(error.response.data.error ?? "Ada Kendala di Server"));
    dispatch(setStatus("failed"));
  }
};
